import { createContext } from "react"

const SearchContext = createContext({
  redirectStatus: false,
  setRedirectStatus: () => {},

  query: "",

  searchState: "",
  searchModalOpen: false,
  setSearchModal: () => {},
})

export default SearchContext
